"use strict";

export default function routes($routeProvider) {
  "ngInject";
  $routeProvider
    .when("/userManagement", {
      template: require("./admin.pug"),
      controller: "AdminController",
      controllerAs: "admin",
      authenticate: "admin"
    })
    .when("/signup", {
      template: require("./signup/signup.pug"),
      controller: "SignupController",
      controllerAs: "vm",
      authenticate: "admin"
    })
    .when("/configurations", {
      template: require("./configurations/configurations.pug"),
      controller: "ConfigurationsController",
      controllerAs: "vm",
      authenticate: "admin"
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.routes.ts